import React from "react";
import Button from "./Button";
import PropTypes from 'prop-types';

export default class SearchButton extends React.PureComponent {

    static propTypes = {
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        customerName: PropTypes.string,
        onClick: PropTypes.func,
        language: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    render() {
        if (this.state['loading']) {
            return null;
        }
        return (
            <Button
                onClick={this.props.onClick}
                className= {"button primary-bg height-60 button-search btn-block"}
                buttonType = {"button-search"}
                positionId = {this.props.positionId}
                customerName = {this.props.customerName}
            >
                <i className='fas fa-search'/>
                {window.Translator.getSlug('Search', this.props.language)}
            </Button>
        );
    }
}
